<template lang="pug">
    div#menu
        ul.menu
            li.header
                |menu
            li
                button(@click="$eventBus.$emit('openExperiencia', 'faelPlus')") FAEL+
            li
                button(@click="$eventBus.$emit('openExperiencia', 'faelflix')") FAELFLIX
        ul.contato
            li.header
                |entre em contato
            li
                a(href="tel:08006426002") 0800 642 6002
            // li
            //     a(href="") 41 3333 3333
            li
                a(href="mailto:contato@fael.edu.br") contato@fael.edu.br
        ul.acesse
            li.header
                |acesse o site da
            li
                a(href="https://fael.edu.br") fael.edu.br 
                    img(:src="require('@images/icons/icone-link.png')") 
        span.copyright {{ date }} &copy; FAEL
</template>

<script>
export default {
    name: "component-menu",
    computed: {
        date() {
            return new Date().getFullYear();
        }
    }
}
</script>

<style lang="stylus" scoped src="@components/Menu/Menu.styl"></style>